import type { IconProps } from '../types/IconProps.ts';
export const KeyRound: IconProps = {
    name: 'KeyRound',
    children: [
        `<path d="M10 8q0 1.2.45 2.28c.18.43.1.95-.24 1.26L2.33 18.7a1 1 0 0 0-.33.74V21a1 1 0 0 0 1 1h2.98Q6 22 6 21.98v-1.96q0-.02.02-.02h2.96Q9 20 9 19.98v-2.96q0-.02.02-.02h1.53a1 1 0 0 0 .75-.33l2.25-2.51c.27-.3.7-.4 1.1-.31A6.02 6.02 0 0 0 22 8a6 6 0 0 0-12 0" />`,
        `<circle cx="16.5" cy="7.5" r=".5" />`,
    ]
};